<template>
    <AdminAccountList :pk="'PAL-'" :lockedFilters="lockedFilters" :hidePartnerCompanyFilter="!!partnerId"
        :hideCustomerFilter="true" :hideDepartmentFilter="false" :hideUserTypeFilter="true"
        :userTypeFilterOptions="userTypeFilterOptions">
    </AdminAccountList>
</template>


<script>
import AdminAccountList from '@/views/admin/accounts/AdminAccountList.vue';

export default {
    name: "PartnerAccountList",
    props: {},
    components: {
        AdminAccountList,
    },

    data() {
        return {};
    },

    mounted() { },

    methods: {},

    computed: {
        partnerId() {
            return this.$route.params.partnerCompanyId;
        },
        lockedFilters() {
            var filters = {
                UserTypeIdList: [5],
            };
            if (this.partnerId) {
                filters.PartnerCompanyIdList = [this.partnerId];
            }
            return filters;
        },
        userTypeFilterOptions() {
            return [5];
        },
    },

    watch: {},
};
</script>


<style lang='scss'></style>